import createClient from "./createClient";
export default createClient("/api/rider-app");
